export const cleanUrl = (url) => {
    const queryRegex = new RegExp(/\?.*$/);
    const hashRegex = new RegExp(/#.*$/);
    if (hashRegex.test(url)) {
        url = url.replace(hashRegex, '');
    }
    if (queryRegex.test(url)) {
        url = url.replace(queryRegex, '');
    }
    if (url.endsWith('/')) {
        url = url.replace(/\/$/, '');
    }
    return url;
};
